import React from 'react'
import './styles'

import ExternalLink from '/components/external-link'
import Popover      from '/components/popover'

CHARGE_ID_PATTERN = /^ch|^pi/i
STRIPE_BASE_URL = "https://dashboard.stripe.com/"

urlFor = ({
  provider
  universe_stripe_account_id
  universe_stripe_connect_account_id
  stripe_connect_account_id
})->
  url = new URL STRIPE_BASE_URL
  url.pathname = switch provider
    when 'stripe_connect'
      "#{universe_stripe_connect_account_id}/connect/view-as/#{stripe_connect_account_id}/payments/"
    else "#{universe_stripe_account_id}/payments/"

  url

export default StripeCharges = ({ ticket, hasPopover }) ->
  return null unless ticket

  { payment_references } = ticket
  return null unless num_charges = payment_references.length

  charge = (title) ->
    return null unless title

    url = new URL urlFor ticket

    if title.match CHARGE_ID_PATTERN
      url.pathname += title

    <div key={title} className="charge">
      <span className="title" title={title}>{title}</span>
      <ExternalLink url={url.href} />
    </div>

  chargesGrid = ->
    for c in payment_references
      charge c

  <div className="StripeCharges">
    { if hasPopover and num_charges > 1
        <div className="chargesContainer">
          { charge "#{num_charges}x charges" }
          <Popover title="Charges">
            <div className="PopoverCharges">
              { chargesGrid() }
            </div>
          </Popover>
        </div>
      else
        chargesGrid()
    }
  </div>
